import SkeletonContainer from './SkeletonContainer';
export default SkeletonContainer;
